import { getStampSubDays   } from '../time.js';
import { getStampSubMonths } from '../time.js';
import { getStampAddDays   } from '../time.js';
import { getStampAddMonths } from '../time.js';

export const TIME_UNIT_DAY   = 1;
export const TIME_UNIT_MONTH = 2;

// Пользователь инсайдера видит только те события, которые попадают в окно.
// Границы окна вычисляются отностительно настоящего момента времени.
// options for component b-form-select
export function getWindowDurationOptions() {
  return [
    {
      value: {timeUnit: TIME_UNIT_DAY, amount: 7},
      text: '1 week',
    },
    {
      value: {timeUnit: TIME_UNIT_DAY, amount: 14},
      text: '2 weeks',
    },
    {
      value: {timeUnit: TIME_UNIT_MONTH, amount: 1},
      text: '1 month',
    },
    {
      value: {timeUnit: TIME_UNIT_MONTH, amount: 3},
      text: '3 months',
    },
    {
      value: {timeUnit: TIME_UNIT_MONTH, amount: 12},
      text: '1 year',
    },
    {
      value: null,
      text: 'all'
    },
  ];
}

export function getBegin(stamp, duration) {
  switch(duration.timeUnit) {
    case TIME_UNIT_DAY:
      return getStampSubDays(stamp, duration.amount);
    case TIME_UNIT_MONTH:
      return getStampSubMonths(stamp, duration.amount);
    default:
      throw new Error('Unknown time unit');
  }
}

export function getEnd(stamp, duration) {
  switch(duration.timeUnit) {
    case TIME_UNIT_DAY:
      return getStampAddDays(stamp, duration.amount);
    case TIME_UNIT_MONTH:
      return getStampAddMonths(stamp, duration.amount);
    default:
      throw new Error('Unknown time unit');
  }
}
